import * as requestFromServer from './deliveriesCrud';
import { deliveriesSlice, callTypes } from './deliveriesSlice';

const { actions } = deliveriesSlice;

export const fetchDeliveries = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findDeliveries(queryParams)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_INFO':
        case 'SUCCESS_WITH_WARNING':
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.deliveriesFetched({ totalCount, entities }));
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find deliveries";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchDeliver = (deliverCode) => (dispatch) => {
  if (!deliverCode) {
    return dispatch(actions.deliverFetched({ deliverForView: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getDeliver(deliverCode)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(
            actions.deliverFetched({ deliverForView: response.data.data })
          );
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find deliver";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createDeliver = (deliver) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createDeliver(deliver)
    .then((response) => {
      console.log('createDeliver', response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(
            actions.deliverFetched({ deliverForView: response.data.data })
          );
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          //console.log('createDeliver err', error);
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't create deliver";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const updateDeliver = (deliverForView) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateDeliver(deliverForView)
    .then((response) => {
      console.log('updateDeliver', response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(
            actions.deliverUpdated({ deliverForView: response.data.data })
          );
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update deliver";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteDeliver = (deliverCode) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteDeliver(deliverCode)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.deliverDeleted({ deliverCode }));

          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't close deliver";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const clearDeliver = () => (dispatch) => {
  dispatch(actions.deliverCleared());
};
